export default "__VITE_ASSET__DE6yaVX6__"